import React from 'react'

import { Checkbox } from '@/components/atoms/Checkbox/Checkbox.tsx'
import { cn } from '@/lib/utils.ts'

export interface MenuFilterItem<T extends string = string> {
  id: T
  label: string
  default?: boolean
}

export interface MenuFilterOptions<T extends string = string> {
  menuFilterItems: Array<MenuFilterItem<T>>
}

export interface MenuFilterState<T extends string = string> {
  activeFilters?: Partial<Record<T, boolean>>
}

export interface MenuFilterActions<T extends string = string> {
  onMenuFilterChanged?: (id: T, checked: boolean) => void
}

export interface MenuFilterProps<T extends string = string>
  extends React.HtmlHTMLAttributes<HTMLDivElement>, MenuFilterOptions<T>, MenuFilterState<T>, MenuFilterActions<T> {}

export const MenuFilter = React.forwardRef<HTMLDivElement, MenuFilterProps>(
  ({ className, menuFilterItems, activeFilters, onMenuFilterChanged, ...props }, ref) => (
    <div className={cn('rounded-menu flex w-fit bg-white px-3 py-3.5', className)} ref={ref} {...props}>
      <div className="flex flex-col items-start gap-3">
        {menuFilterItems.map((item) => (
          <div key={item.id} className="flex items-center gap-2">
            <Checkbox
              id={`menu-item-${item.id}`}
              checked={activeFilters?.[item.id] ?? item.default}
              onCheckedChange={(checked) => onMenuFilterChanged?.(item.id, !!checked)}
            />
            <label
              htmlFor={`menu-item-${item.id}`}
              className="text-sm peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
              {item.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
)
